<template>
  <div class="extended-response">
    <div class="question-container">
      <div class="question-content">
        <span v-html="questionContent.QuestionContent[0]"></span>
      </div>
      <div v-if="questionContent.SecondColumn" class="question-media">
        <span v-html="questionContent.SecondColumn[0]"></span>
      </div>
      <div class="hr-container">
        <hr>
      </div>
      <div class="question-solution" v-show="showSolution">
        <div class="solution-content">
          <span v-html="questionContent.Solution[0]"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import { mapGetters } from 'vuex'

export default {
  name: 'ExtendedResponse',
  props: {
    questionContent: Object,
    bookTitle: String,
    chapter: String,
    section: String
  },
  computed: {
    ...mapGetters({
      showSolution: 'question/getShowSolution'
    })
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.extended-response {
  .question-container {
    .question-content {
      width: 50%;
      margin: 32px 0px;
      display: inline-block;
      padding-right: $column-padding;
    }
    .question-media {
      width: 50%;
      float:right;
      padding-left: $column-padding;
    }
    .hr-container {
      width: 50%;
      margin-bottom: $question-hr-margin-bottom;
      padding-right: $column-padding;
    }
    .question-solution {
      width: 50%;
      padding-right: $column-padding;
      .solution-content {
        background: $question-correct-background-color;
        border-radius: $solution-border-radius;
        margin: 0px 4px;
        padding: $solution-content-padding;
        ::v-deep p {
          margin-bottom: 0px !important;
        }
      }
    }
  }
@media (max-width: 768px) {
  .question-container {
    .question-content, .hr-container, .question-solution {
      @include mobile-sizing;
    }
    .question-media {
      @include mobile-sizing;
      float: none;
    }
  }
}
}
</style>
